import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {Checkbox} from 'ui-library';
import i18n from 'i18n';

module.exports = createClass({
  displayName: 'SearchFilter',

  propTypes: {
    text: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    filters: PropTypes.object,
    className: PropTypes.string
  },

  getDefaultProps() {
    return {
      filters: {},
      onChange: () => {}
    };
  },

  getInitialState() {
    return {
      active: false
    };
  },

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  },

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  },

  handleClickOutside(ev) {
    if (!!this.container && !this.container.contains(ev.target)) {
      this.setState({active: false});
    }
  },

  toggle() {
    this.setState({
      active: !this.state.active
    });
  },

  _onChange(filterName, item, key) {
    let {filters} = this.props;
    filters[filterName].items[key].checked = !item.checked;
    const activeFilters = this.getActiveFilters();
    if (this.props.onChange) this.props.onChange(filters, activeFilters);
    this.forceUpdate();
  },

  getActiveFilters() {
    const {filters} = this.props;

    let activeFilters = filters.reduce((result, options, filter) => {
      result[filter] = options.items.reduce((actives, item) => {
        if (item.checked) actives.push(item.value);
        return actives;
      }, []);

      return result;
    }, {});

    return activeFilters;
  },

  render() {
    const {
      className,
      filters,
      text = i18n.get('SEARCH_FILTER_DEFAULT_TEXT')
    } = this.props;
    const {active} = this.state;
    let dropDownFiltes;
    let classes = 'vf-search-filter';

    if (className) classes += ' ' + className;
    if (active) classes += ' active';

    dropDownFiltes = filters.map((options, filter) => {
      let optionItems = [];

      if (options.items.length) {
        optionItems = options.items.map((item, key) => {
          return (
            <li key={key}>
              <Checkbox key={key} onChange={this._onChange.bind(null, filter, item, key)} checked={item.checked}>
                {item.label}
              </Checkbox>
            </li>
          );
        });
      }

      return (
        <div key={filter}>
          <div className='vf-search-filter-category'>
            <span>
              {options.title}
            </span>
          </div>
          <ul className='vf-clear-ul'>
            {optionItems}
          </ul>
        </div>
      );
    });

    return (
      <div ref={r => this.container = r} className={classes}>
        <div className='vf-search-filter-select vf-clickable' onClick={this.toggle}>
          {text}<i className={active ? 'vf-icon icon-caret-up-two' : 'vf-icon icon-caret-down-two'}></i>
        </div>
        <div className='vf-search-filter-dropdown padding-1x'>
          {dropDownFiltes}
        </div>
      </div>
    );
  }
});
